import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenaccessComponent } from './simple-icons-openaccess.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenaccessComponent ],
    exports:      [ SimpleIconsOpenaccessComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenaccessModule {}
